import { SET_AUTH0_TOKEN, SET_ADMIN_SSO_PROFILE, LOGOUT, RESET } from '../actions/actionTypes';

const preState = {
	auth0Token: null,
	adminSSOProfile: null,
	adminPermissions: null,
	justLoggedOut: false,
};

const authReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, adminSSOProfile, auth0Token } = action;

	switch (type) {
		case RESET:
			return preState;
		case LOGOUT:
			return { ...preState, justLoggedOut: true };
		case SET_AUTH0_TOKEN:
			localStorage.setItem('access_token', auth0Token);
			return { ...stateDup, auth0Token, justLoggedOut: false };
		case SET_ADMIN_SSO_PROFILE:
			return {
				...stateDup,
				adminSSOProfile,
				justLoggedOut: false,
			};
		default:
			return state;
	}
};

export default authReducer;
